import CompliancePill from '@/components/ui/CompliancePill';
import { actionStatusLabel, actionStatusRating } from '../actionStatus';
import type { ActionDisplayStatus } from '../types';

export default function ActionStatusPill({ status, className }: { status: ActionDisplayStatus; className?: string }) {
  return <CompliancePill text={actionStatusLabel(status)} stop={actionStatusRating(status)} className={className} />;
}
